import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from "react";
import "./Projects.css";
import projectsData from "./Projects.json";

const Projects = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return (
    <section data-aos="fade-up" id="projects" className="portfolio-mf pt-5">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div className="title-box text-center">
              <h3 className="title-a">Projects</h3>
              <div className="line-mf"></div>
            </div>
          </div>
        </div>
        <div className="row">
          {projectsData.map((project) => (
            <div className="col-md-4" data-aos="fade-up">
              <div className="work-box">
                <div className="work-img">
                  <img
                    src={project.img}
                    alt="fitForLife"
                    className="img-fluid"
                  />
                </div>
                <div className="work-content">
                  <div className="row">
                    <div className="col-sm-8">
                      <h2 className="w-title">{project.projectName}</h2>
                      <p className="w-more">{project.projectDetails}</p>
                      <div className="w-more">
                        <a href={project.liveSite} className="w-ctegory">
                          Live site
                        </a>{" "}
                        |{" "}
                        <a href={project.code} className="w-ctegory">
                          Code
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
